import { Component } from '@angular/core';

@Component({
    selector: 'app-lista-notificacao',
    templateUrl: './lista-notificacao.component.html',
    styleUrl: './lista-notificacao.component.css',
    standalone: false
})
export class ListaNotificacaoComponent {

}
